import React, { useState } from 'react';
import { Input } from '../components/ui/Input';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { rules } from '../utils/mockData';
import { ChevronDown, Download } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function RulesPage() {
  const [expandedId, setExpandedId] = useState<string | null>(null);
  return <div className="p-4 md:p-8 pb-24 max-w-4xl mx-auto" data-id="element-185">
      <div className="mb-8" data-id="element-186">
        <h1 className="text-3xl font-bold text-text mb-2" data-id="element-187">Rules & Permits</h1>
        <p className="text-text-muted" data-id="element-188">
          Stay compliant with local fishing regulations.
        </p>
      </div>

      <div className="mb-8" data-id="element-189">
        <Input placeholder="Search regulations..." className="w-full" data-id="element-190" />
      </div>

      <div className="space-y-4" data-id="element-191">
        {rules.map(rule => {
        const isExpanded = expandedId === rule.id;
        const Icon = rule.icon;
        return <Card key={rule.id} variant="interactive" className="overflow-hidden" onClick={() => setExpandedId(isExpanded ? null : rule.id)} data-id="element-192">
              <div className="p-5 flex items-start justify-between" data-id="element-193">
                <div className="flex items-start space-x-4" data-id="element-194">
                  <div className="p-3 bg-primary/10 rounded-xl text-primary" data-id="element-195">
                    <Icon size={24} data-id="element-196" />
                  </div>
                  <div data-id="element-197">
                    <h3 className="font-bold text-text text-lg" data-id="element-198">
                      {rule.title}
                    </h3>
                    <p className="text-text-muted" data-id="element-199">{rule.summary}</p>
                  </div>
                </div>
                <motion.div animate={{
              rotate: isExpanded ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-200">
                  <ChevronDown className="text-text-muted" data-id="element-201" />
                </motion.div>
              </div>

              <AnimatePresence data-id="element-202">
                {isExpanded && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-203">
                    <div className="px-5 pb-5 pt-0 pl-[4.5rem]" data-id="element-204">
                      <p className="text-text-muted leading-relaxed border-t border-border pt-4" data-id="element-205">
                        {rule.details}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </Card>;
      })}
      </div>

      <div className="mt-8" data-id="element-206">
        <Button className="w-full" size="lg" data-id="element-207">
          <Download className="mr-2 h-5 w-5" data-id="element-208" />
          Download 2024 Guide PDF
        </Button>
      </div>
    </div>;
}